import React from "react";
import styles from "./index.module.css";
import img1 from "@/assets/images/custom-img-1.png";
import img2 from "@/assets/images/custom-img-2.png";
import img3 from "@/assets/images/custom-img-3.png";
import img4 from "@/assets/images/custom-img-4.png";

const CustomModule = () => {
  return (
    <div className={styles.customModule}>
      <div className={styles.customModuleTitle}>
        内容/模板均可自定义，生成更合心意
      </div>
      <div className={styles.customModuleContent}>
        <div className={styles.customModuleContentItem}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={img1.src} alt="custom-img-1" width={270} />
          <div className={styles.customModuleContentItemTitle}>
            可修改内容大纲
          </div>
        </div>
        <div className={styles.customModuleContentItem}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={img2.src} alt="custom-img-2" width={270} />
          <div className={styles.customModuleContentItemTitle}>
            可选择PPT页数
          </div>
        </div>
        <div className={styles.customModuleContentItem}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={img3.src} alt="custom-img-3" width={270} />
          <div className={styles.customModuleContentItemTitle}>
            可选任意风格模板
          </div>
        </div>
        <div className={styles.customModuleContentItem}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={img4.src} alt="custom-img-4" width={270} />
          <div className={styles.customModuleContentItemTitle}>
            可切换单页布局样式
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CustomModule);
